module.exports = __webpack_public_path__ + "img/doc__ru__id_doc.2b1afe70.png";